var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from "react";
export default (function (_ref) {
  var style = _ref.style;
  return React.createElement("svg", {
    id: "L3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 0 0",
    xmlSpace: "preserve",
    style: _extends({
      width: 100,
      display: "inline-block"
    }, style)
  }, React.createElement("circle", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: "4",
    cx: "50",
    cy: "50",
    r: "44",
    style: {
      opacity: 0.5
    }
  }), React.createElement("circle", {
    fill: "#fff",
    stroke: "#e74c3c",
    strokeWidth: "3",
    cx: "8",
    cy: "54",
    r: "6",
    transform: "rotate(248.832 50 50.7648)"
  }, React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "2s",
    type: "rotate",
    from: "0 50 48",
    to: "360 50 52",
    repeatCount: "indefinite"
  })));
});